import type { Release } from '../releases.ts';

export default {
  version: '0.18.5',
  date: '2026-10-03',
  title: 'Live recordings in Monitor and Jobs',
  summary: [
    'Monitor has a Live tab listing every recording from live sources and watch folders, with filters',
    'System status → Jobs lists live recordings as their own kind',
  ],
  features: [],
  fixes: [
    'Monitor has a Live tab: every recording from live sources and live watch folders, recording now, waiting for a stream, recorded or failed, with its length, source and who started it; filter by time, source and status',
    'System status → Jobs lists live recordings as their own kind, and the overview counts them',
  ],
} satisfies Release;
